export default __webpack_public_path__ + "static/media/Gauntlets of Brutal Carnage.c1452d71.jpg";